module.exports = __webpack_public_path__ + "static/media/button-arrow.b5310b7c.svg";